import { getUiConfig } from '@/config/client/getUiConfig';
import { profileSDK } from '@/sdk/client/profileSDK';

export async function getXid(): Promise<string> {
  let options = {};

  if (process.env.NODE_ENV !== 'development' && !window.location.hostname.includes('dev-ond')) {
    const uiConfig = getUiConfig();

    options = { cookieDomain: uiConfig.authCookieDomain };
  }

  const xidResponse = await profileSDK.getXid(options);

  if (xidResponse.xid) {
    return xidResponse.xid;
  }

  console.error('[getXid][Client] Failed to retrieve XID from profile SDK');

  return '';
}
